/*************************************************/
/* Vue                                           */
/*************************************************/
import { createApp,h } from 'vue';
import {createRouter,createWebHistory} from "vue-router";
import Employees from './vue/employees.vue';

const employeesAppElement = document.querySelector("#employeesApp");
if (employeesAppElement) {
    const employeesNodeId = employeesAppElement.dataset.employeesNodeId;
    const showFilters = employeesAppElement.dataset.showFilters;
    const headline = employeesAppElement.dataset.headline;

    const router = createRouter({
        history: createWebHistory(),
        routes: [{path : window.location.pathname,component:Employees}]
    });

    const seedData = {employeesNodeId:employeesNodeId,showFilters:showFilters,headline:headline};

    const employeesApp = createApp({
        data() {return seedData},
        render: ()=>h(Employees)
    },seedData);

    employeesApp.use(router);
    router.isReady().then(() => employeesApp.mount(employeesAppElement));
}